(function(wtcpJs) {
    "use strict";
    class ErrorResponse {
        constructor() {
            this.errorCode = 0;
            this.errorMessage = "";
        }
    }

    wtcpJs.ErrorResponse = ErrorResponse;
})(WtcpJs || (WtcpJs = {}));